<template>
    <t-space direction="vertical" align="start" style="width: 100%;">
        <t-space style="width: 100%;"></t-space>
        <t-space direction="horizontal">
            <t-space></t-space>
            <t-card title="搜索栏" style="width: 85.5vw;  height: 13vh;">
                <t-space>
                    <t-input v-model="searchBillOfDocumentId" placeholder="请输入单据编号">
                        <template #prefix-icon>
                            <search-icon />
                        </template>
                    </t-input>
                    <t-input v-model="searchTransactor" placeholder="请输入经办人">
                        <template #prefix-icon>
                            <search-icon />
                        </template>
                    </t-input>
                    <t-select v-model="searchWarehouseId" placeholder="请选择仓库"  clearable @change="searchSelectChange">
                            <t-option v-for="item in warehouseList" :key="item.warehouseId" :value="item.warehouseId" :label="item.warehouseName"></t-option> 
                    </t-select>
                    <t-select v-model="searchStatus" placeholder="请选择单据状态"  clearable @change="searchStatisSelectChange">
                            <t-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label"></t-option> 
                    </t-select>
                    <t-date-range-picker v-model="searchDate"  enable-time-picker />  
                    <t-button @click="Search">搜索</t-button>
                    <t-button @click="ClearSearchCritera">清除筛选</t-button>
                </t-space>
            </t-card>
        </t-space>
        <t-space direction="horizontal">
            <t-space>
            </t-space>
            <t-card>
                <t-space direction="vertical"  style="width: 82.7vw;">
                    <t-row>
                        <t-col>
                            <t-space>
                                <t-button @click="AddNewBillOfDocument">新增采购换货单</t-button>
                                <t-button @click="showColumnsConfig">进行列配置</t-button>
                            </t-space>
                        </t-col>
                        <!-- 打印弹窗-->
                        <t-dialog   v-model:visible="showPrintDialog"
                                    id="printDialog"
                                    header="采购换货单"
                                    :top="'50px'"
                                    :width="'98vw'"
                                    :height="'40vh'"
                                    :cancelBtn="null"
                                    :on-confirm="confrimPrintTemplate"
                                    cancel>
                            <t-space direction="horizontal">
                                <!--设计画板-->
                                <div id="hiprint-printTemplate" class="hiprint-printTemplate"></div>
                                <t-select label="模版：" placeholder="请选择打印模版" @change="SelectPrintTemplateChange">
                                    <t-option v-for="item in templateOption" :key="item.value" :value="item.value" :label="item.label" ></t-option>
                                </t-select>
                            </t-space>
                        </t-dialog>
                        <!-- 查看具体条目内容细节弹窗-->
                        <t-dialog   v-model:visible="showBillOfDocumentDetailsDialog"
                                    header="采购换货单"
                                    :width="'98vw'"
                                    :height="'40vh'"
                                    @confirm="()=>{ showBillOfDocumentDetailsDialog = false}"
                                    cancel>
                                    <t-row style="width: 100%;">
                                        <t-descriptions :column="6">
                                            <t-descriptions-item label="单据编号">{{billOfDocumentDetailsHead.billOfDocumentId}}</t-descriptions-item>
                                            <t-descriptions-item label="所属仓库">{{billOfDocumentDetailsHead.billOfDocumentWarehouse}}</t-descriptions-item>
                                            <t-descriptions-item label="所属部门">{{billOfDocumentDetailsHead.billOfDocumentDepartment}}</t-descriptions-item>
                                            <t-descriptions-item label="供应商">{{billOfDocumentDetailsHead.billOfDocumentUnit}}</t-descriptions-item>
                                            <t-descriptions-item label="经办人">{{billOfDocumentDetailsHead.billOfDocumentTransactor}}</t-descriptions-item>
                                            <t-descriptions-item label="摘要">{{billOfDocumentDetailsHead.billOfDocumentAbstract}}</t-descriptions-item>
                                        </t-descriptions>
                                    </t-row>
                                    <t-row>
                                        <t-table
                                                    :max-height="400"
                                                    :data="billOfDocumentDetailsGoodsList"
                                                    v-model:displayColumns="dispalyColumns"
                                                    :columns="billOfDocumentDetailsColumns"
                                                    :pagination="addAndDetailsPagination">
                                        </t-table>
                                    </t-row>
                        </t-dialog>
                        <!-- 新增单据弹窗-->
                        <t-dialog   v-model:visible="showAddBillOfDocumentDialog"
                                    header="新增采购换货单"
                                    :width="'98vw'"
                                    :height="'40vh'"
                                    confirmOnEnter
                                    :onConfirm="SubmitAddBillOfDocument"
                                    cancel>
                                <t-form
                                    :data="billOfDocumentCreateHead"
                                    :rules="rules"
                                    layout="vertical">
                                        <t-row>
                                            <t-form-item label="单据编号" name="id">
                                                <t-input v-model="billOfDocumentCreateHead.id"></t-input>
                                            </t-form-item>
                                            <t-form-item label="所属仓库" name="create_warehouse">
                                                <!-- <t-input v-model="billOfDocumentCreateHead.create_warehouse"></t-input> -->
                                                <t-select v-model="billOfDocumentCreateHead.create_warehouse" placeholder="请选择仓库"  clearable @change="SelectChange"> //TODO
                                                    <t-option v-for="item in warehouseList" :key="item.warehouseId" :value="item.warehouseId" :label="item.warehouseName"></t-option> //TODO
                                                </t-select>
                                            </t-form-item>
                                            <t-form-item label="所属部门" name="department">
                                                <t-input v-model="billOfDocumentCreateHead.department"></t-input>
                                            </t-form-item>
                                            <t-form-item label="供应商" name="unit">
                                                <!-- <t-input v-model="billOfDocumentCreateHead.unit"></t-input> -->
                                                <t-select v-model="billOfDocumentCreateHead.unit" placeholder="请选择供应商"  clearable @change="unitSelectChange">
                                                    <t-option v-for="item in cooperativeList" :key="item.name" :value="item.name" :label="item.name"></t-option> 
                                                </t-select>
                                            </t-form-item>
                                            <t-form-item label="经办人" name="transactor">
                                                <!-- <t-input v-model="billOfDocumentCreateHead.transactor"></t-input> -->
                                                <t-select v-model="billOfDocumentCreateHead.transactor" placeholder="请选择经办人"  clearable @change="transactorSelectChange">
                                                    <t-option v-for="item in staffList" :key="item.staffName" :value="item.staffName" :label="item.staffName"></t-option> 
                                                </t-select>
                                            </t-form-item>
                                            <t-form-item label="摘要" name="abstract">
                                                <t-input v-model="billOfDocumentCreateHead.abstract"></t-input>
                                            </t-form-item>
                                        </t-row>
                                        <t-row>
                                            <t-button @click="AddCreateBillOfDocumentGoodsListItem">
                                                新增采购换货单商品条目
                                            </t-button>
                                        </t-row>
                                        <t-row>
                                        <t-table
                                            :max-height="400"
                                            :columnControllerVisible="columnsConfigVisible"
                                            :column-controller="columControllerConfig"
                                            :onColumnChange="onDisplayColumnsChange"
                                            ref="tableRef"
                                            row-key="index"
                                            :columns="billOfDocumentCreateColumns"
                                            :editable-row-keys="editableRowKeys"
                                            cell-empty-content="-"
                                            :data="billOfDocumentCreateDataGoodsList"
                                            v-model:displayColumns="dispalyColumns"
                                            @row-edit="onRowEdit"
                                            :pagination="addAndDetailsPagination"
                                            >
                                        </t-table>
                                    </t-row>
                                </t-form>
                        </t-dialog>
                    </t-row>
                    <!---整体的单据列表--->
                    <t-table
                            row-key="index"
                            :data="billOfDocumentList"
                            :columns="billOfDocumentColumns"
                            :stripe="false"
                            :bordered="false"
                            table-layout="fixed"
                            :pagination="pageConfig"
                            cell-empty-content="-"
                            disableDataPage="true"
                            resizable
                            lazy-load>
                    </t-table>
                </t-space>
            </t-card>
            <t-space>
            </t-space>
        </t-space>
    </t-space>
</template>

<script lang="jsx" setup>
import { computed,ref,reactive,onMounted} from 'vue'
import { Input,NotifyPlugin } from 'tdesign-vue-next';
import request from '@/request/request.js';
import { hiprint,defaultElementTypeProvider } from "vue-plugin-hiprint";
import { ErrorCircleFilledIcon, CheckCircleFilledIcon, CloseCircleFilledIcon } from 'tdesign-icons-vue-next';

const searchFlag = ref(false)
const searchDate = ref([])
const searchBillOfDocumentId = ref()
const searchTransactor = ref()
const searchWarehouseId = ref()
const addAndDetailsPagination = ref({
    total: 100,
    pageSize: 100,
    showPageSize: false,
    totalContent: false,
    showPageNumber: false
})

const cooperativeList = ref([])
const searchStatus = ref()
const statusList = ref([
    {label: '待审批', value: '待审批'},
    {label: '已审批', value: '已审批'},
    {label: '已驳回', value: '已驳回'},

])
const searchStatisSelectChange = (value,context)=>{
    console.log(value)
    if(context.option) {
        searchStatus.value = context.option.key
    }
}
const fetchCooperative = ()=>{
    let param = {
        binding_user_id: sessionStorage.getItem('user_id'),
        page_size: 65535,
        page_number: 1,
        type: '供应商'
    }
    request.SearchCooperativePartnerList(param,(res)=>{
        if(res.data && res.data.success) {
            cooperativeList.value = res.data.data.resultList
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '合作方数据请求失败.',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '合作方数据请求失败.' + err,
            duration: 3000
        })
    })
}
const unitSelectChange = (value,context)=>{
    if(context.option) {
        billOfDocumentCreateHead.unit = context.option.label
    }
}
const Search = ()=>{
    searchFlag.value = true
    let criteria = {
        warehouseId: searchWarehouseId.value,
        billOfDocumentId: searchBillOfDocumentId.value,
        transactor: searchTransactor.value,
        begin_time: searchDate.value[0],
        status: searchStatus.value,
        end_time: searchDate.value[1]
    }
    request.SearchBill(0,pageConfig.value.pageSize,"采购换货单",criteria,
    (res)=>{
        if(res.data.success) {
            billOfDocumentList.value = []
            billOfDocumentListGoodsList.value = []
            res.data.data.list.forEach(item => {
                billOfDocumentList.value.push(item.billOfDocumentTableHead)
                billOfDocumentListGoodsList.value.push(item.billOfDocumentGoodsList)
            })
            let index = 0
            billOfDocumentList.value.forEach(item => {
                item.index = index
                index++
            })
            pageConfig.value.total = res.data.data.total
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '采购换货单信息请求失败.' + res.data.tag,
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '采购换货单信息请求失败.' + err,
            duration: 3000
        })
    })
}
const ClearSearchCritera =()=>{
    searchFlag.value = false
    searchDate.value = []
    searchStatus.value = null
    searchBillOfDocumentId.value = null
    searchTransactor.value = null
    searchWarehouseId.value = null
    pageConfig.value.total = parseInt(sessionStorage.getItem("采购换货单总数"))
    request.RequestBillOfDocumentList(0,8,"采购换货单",null,(res)=>{
        if(res.data.success) {
            let headList = []
            let goodsList = []
            res.data.data.forEach(item =>{
                headList.push(item.billOfDocumentTableHead)
                goodsList.push(item.billOfDocumentGoodsList)
            })
            billOfDocumentList.value = headList
            billOfDocumentListGoodsList.value = goodsList
            console.log("onMounted billOfDocumentListGoodsList",billOfDocumentListGoodsList)
            let index = 0
            billOfDocumentList.value.forEach((item)=>{
                if(!Object.hasOwn(item,'index')) {
                    item.index = index
                    index++
                }
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            theme: '数据获取失败',
            content: '获取采购订单失败' + err,
            duration: 3000
        })
    })
}
const searchSelectChange = (value,context)=>{
    console.log(value)
    if(context.option) {
        searchWarehouseId.value = context.option.key
    }
}
hiprint.init({
    providers: [defaultElementTypeProvider()],
});
let hiprintTemplate = ref()

const buildDesigner = () => {
  // new hiprint.PrintTemplate 的返回值是一个模板的实例
  // 传入的参数各种的配置项
  // settingContainer：属性栏面板
    hiprintTemplate.value = new hiprint.PrintTemplate({
        settingContainer: "#PrintElementOptionSetting",
        template: {
            panels: [{
                width: 300,
                height: 200
            }]
        }
    });
    // 构建一个设计模板，指定容器，是否开启网格展示
    hiprintTemplate.value.design("#hiprint-printTemplate",{grid: true});
};

onMounted(()=>{
    request.RequestBillOfDocumentAmountByType("采购换货单")
    request.RequestBillOfDocumentList(0,8,"采购换货单",null,(res)=>{
        if(res.data.success) {
            let headList = []
            let goodsList = []
            res.data.data.forEach(item =>{
                headList.push(item.billOfDocumentTableHead)
                goodsList.push(item.billOfDocumentGoodsList)
            })
            billOfDocumentList.value = headList
            billOfDocumentListGoodsList.value = goodsList
            let index = 0
            billOfDocumentList.value.forEach((item)=>{
                if(!Object.hasOwn(item,'index')) {
                    item.index = index
                    index++
                }
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            theme: '数据获取失败',
            content: '获取采购换货单失败' + err,
            duration: 3000
        })
    })
    let config = JSON.parse(sessionStorage.getItem("config"))
    for(let i = 0; i< config.length; i++) {
        if(config[i].type === "采购换货单") {
            Config.value = config[i]
            ConfigRead()
            break
        }
    }
    request.RequestQueryWarehouseInfo(0,8,null,
    (res)=>{
        if(res.data.success) {
            res.data.data.forEach(element => {
                warehouseList.value.push(element)
            });
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '仓库信息请求失败。' + res.data.message,
            })
        }
    },
    (err)=>{
        NotifyPlugin.error({
                title: "请求失败",
                content: '仓库信息请求失败.' + err,
            })
    })
    buildDesigner()
    fetchStaffList()
    fetchCooperative()
})


const rules = {
    id: [
        { required: true, message: '请输入单据编号', trigger: 'submit' },
        { whitespace: true, message: '编号不能为空' }
    ],
    create_warehouse: [
        { required: true, message: '请输入所属仓库', trigger: 'submit' },
        { whitespace: true, message: '所属仓库不能为空' }
    ],
    transactor: [
        { required: true, message: '请输入经办人', trigger: 'submit' },
        { whitespace: true, message: '经办人不能为空' }
    ]
}
const warehouseList = ref([])
const tableRef = ref()
const currentSaveId = ref('')
const bufferRowData = ref({})
const Config = ref({})
const editableRowKeys = ref([''])
const columnsConfigVisible = ref(false)
const showAddBillOfDocumentDialog = ref(false)
const showBillOfDocumentDetailsDialog = ref(false) 
const showPrintDialog = ref(false)
const billOfDocumentDetailsHead = ref({})
const billOfDocumentCreateHead = reactive({
    layout: 'inline',
    id: '',
    create_datatime: '',
    create_warehouse: '',
    department: '',
    unit: '',
    transactor: '',
    abstract: '',
    remark: '',
    accrual: ''
})
const templateOption = ref([])
const printTime = ref()
const billOfDocumentDetailsGoodsList = ref([])  //细节查看时的商品列表
const billOfDocumentCreateDataGoodsList = ref([]) //新建时填写的商品列表
const billOfDocumentList = ref([])  //外部整体表单的商品列表
const billOfDocumentListGoodsList = ref([]) //商品详情中的列表的总和

const dispalyColumns = ref(['billOfDocumentGoodsId',
                            'billOfDocumentGoodsName',
                            'billOfDocumentGoodsWeight',
                            'billOfDocumentGoodsHeight',
                            'billOfDocumentGoodsLength',
                            'billOfDocumentBrand',
                            'billOfDocumentGoodsAmount',
                            'billOfDocumentModel',
                            'billOfDocumentPlaceOfProduction',
                            'billOfDocumentGoodsPrice',
                            'batchNumber',
                            'qualityGuaranteePeriod',
                            'discount',
                            'billOfDocumentGoodsPriceIncludeTax',
                            "operate"
                        ])
const pageConfig = ref({
    pageSize: 8,
    defaultCurrent: 1,
    defaultPageSize: 8,
    total: parseInt(sessionStorage.getItem("采购换货单总数")),
    showPageSize: false,
    onCurrentChange: (number,pageInfo)=>{
        if(searchFlag.value == false) {
            console.log("current change",number,pageInfo);
            request.RequestBillOfDocumentList(number,pageInfo.pageSize,"采购换货单",null,(res)=>{
                if(res.data.success) {
                    let headList = []
                    let goodsList = []
                    res.data.data.forEach(item =>{
                        headList.push(item.billOfDocumentTableHead)
                        goodsList.push(item.billOfDocumentGoodsList)
                    })
                    billOfDocumentList.value = headList
                    billOfDocumentListGoodsList.value = goodsList
                    console.log("onMounted billOfDocumentListGoodsList",billOfDocumentListGoodsList)
                    let index = 0
                    billOfDocumentList.value.forEach((item)=>{
                        if(!Object.hasOwn(item,'index')) {
                            item.index = index
                            index++
                        }
                    })
                }
                },(err)=>{
                    NotifyPlugin.error({
                        theme: '数据获取失败',
                        content: '获取采购换货单失败' + err,
                        duration: 3000
                    })
                }
            )
        } else {
            let criteria = {
                warehouseId: searchWarehouseId.value,
                billOfDocumentId: searchBillOfDocumentId.value,
                transactor: searchTransactor.value,
                begin_time: searchDate.value[0],
                end_time: searchDate.value[1]
            }
            request.SearchBill(number,pageInfo.pageSize,"采购换货单",criteria,
            (res)=>{
                if(res.data.success) {
                    billOfDocumentList.value = []
                    billOfDocumentListGoodsList.value = []
                    res.data.data.list.forEach(item => {
                        billOfDocumentList.value.push(item.billOfDocumentTableHead)
                        billOfDocumentListGoodsList.value.push(item.billOfDocumentGoodsList)
                    })
                    let index = 0
                    billOfDocumentList.value.forEach(item => {
                        item.index = index
                        index++
                    })
                    pageConfig.value.total = res.data.data.total
                }else {
                    NotifyPlugin.error({
                        title: "请求失败",
                        content: '采购换货单信息请求失败.' + res.data.tag,
                        duration: 3000
                    })
                }
            },(err)=>{
                NotifyPlugin.error({
                    title: "请求失败",
                    content: '采购换货单信息请求失败.' + err,
                    duration: 3000
                })
            })
        }
    }
})
const columControllerConfig = computed(()=>({
    hideTriggerButton: true,
    fields: ['billOfDocumentGoodsId',
            'billOfDocumentGoodsName',
            'billOfDocumentGoodsWeight',
            'billOfDocumentGoodsHeight',
            'billOfDocumentGoodsLength',
            'billOfDocumentBrand',
            'billOfDocumentGoodsAmount',
            'billOfDocumentModel',
            'billOfDocumentPlaceOfProduction',
            'billOfDocumentGoodsPrice',
            'batchNumber',
            'qualityGuaranteePeriod',
            'discount',
            'billOfDocumentGoodsPriceIncludeTax'
            ],
            dialogProps: { 
                preventScrollThrough: true,
                onCancel:(context)=>{
                    console.log(context)
                    columnsConfigVisible.value = false
                },
                onCloseBtnClick: (context)=>{
                    console.log(context)
                    columnsConfigVisible.value = false
                },
                onConfirm: (context)=>{
                    console.log(context)
                    columnsConfigVisible.value = false
                }
            },
            checkboxProps: {
                change:(value) => {
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsId') Config.value.idVisible = !Config.value.idVisible
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsName') Config.value.nameVisible = !Config.value.nameVisible
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsWeight') Config.value.weightVisible = !Config.value.weightVisible
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsHeight') Config.value.heightVisible = !Config.value.heightVisible
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsLength') Config.value.lengthVisible = !Config.value.lengthVisible
                    if(value.currentColumn.colKey === 'billOfDocumentBrand') Config.value.brandVisible = !Config.value.brandVisible
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsAmount') Config.value.amountVisible = !Config.value.amountVisible
                    if(value.currentColumn.colKey === 'billOfDocumentModel') Config.value.modelVisible = !Config.value.modelVisible
                    if(value.currentColumn.colKey === 'billOfDocumentPlaceOfProduction') Config.value.placeOfProductionVisible = !Config.value.placeOfProductionVisible
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsPrice') Config.value.priceVisible = !Config.value.priceVisible
                    if(value.currentColumn.colKey === 'batchNumber') Config.value.batchNumberVisible = !Config.value.batchNumberVisible
                    if(value.currentColumn.colKey === 'qualityGuaranteePeriod') Config.value.qualityGuaranteePeriodVisible = !Config.value.qualityGuaranteePeriodVisible
                    if(value.currentColumn.colKey === 'discount') Config.value.discountVisible = !Config.value.discountVisible
                    if(value.currentColumn.colKey === 'billOfDocumentGoodsPriceIncludeTax') Config.value.priceIncludeTaxVisible = !Config.value.priceIncludeTaxVisible
                    ConfigRead()
                }
            }
    
}))
const billOfDocumentDetailsColumns = ref([
    { 
        title: '商品编号',
        colKey: 'billOfDocumentGoodsId'
    },
    { 
        title: '商品名称',
        colKey: 'billOfDocumentGoodsName'
    },
    { 
        title: '商品重量',
        colKey: 'billOfDocumentGoodsWeight'
    },
    { 
        title: '商品高度',
        colKey: 'billOfDocumentGoodsHeight'
    },
    { 
        title: '商品长度',
        colKey: 'billOfDocumentGoodsLength'
    },
    { 
        title: '商品品牌',
        colKey: 'billOfDocumentBrand'
    },
    { 
        title: '商品数量',
        colKey: 'billOfDocumentGoodsAmount'
    },
    { 
        title: '商品规格',
        colKey: 'billOfDocumentModel'
    },
    { 
        title: '商品产地',
        colKey: 'billOfDocumentPlaceOfProduction'
    },
    { 
        title: '商品单价',
        colKey: 'billOfDocumentGoodsPrice'
    },
    { 
        title: '批次号',
        colKey: 'batchNumber'
    },
    { 
        title: '保质期',
        colKey: 'qualityGuaranteePeriod'
    },
    { 
        title: '享受折扣',
        colKey: 'discount'
    },
    { 
        title: '含税单价',
        colKey: 'billOfDocumentGoodsPriceIncludeTax'
    },
])
const billOfDocumentCreateColumns = ref([
{ 
        title: '商品编号',
        colKey: 'billOfDocumentGoodsId',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品名称',
        colKey: 'billOfDocumentGoodsName',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品重量',
        colKey: 'billOfDocumentGoodsWeight',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品高度',
        colKey: 'billOfDocumentGoodsHeight',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品长度',
        colKey: 'billOfDocumentGoodsLength',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品品牌',
        colKey: 'billOfDocumentBrand',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品数量',
        colKey: 'billOfDocumentGoodsAmount',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品规格',
        colKey: 'billOfDocumentModel',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品产地',
        colKey: 'billOfDocumentPlaceOfProduction',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '商品单价',
        colKey: 'billOfDocumentGoodsPrice',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '批次号',
        colKey: 'batchNumber',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '保质期',
        colKey: 'qualityGuaranteePeriod',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '享受折扣',
        colKey: 'discount',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    { 
        title: '含税单价',
        colKey: 'billOfDocumentGoodsPriceIncludeTax',
        edit:{
            component: Input,
            showEditIcon: false
        }
    },
    {
        title: '操作栏',
        colKey: 'operate',
        width: 150,
        cell: (h, { row }) => {
            const editable = editableRowKeys.value.includes(row.index);
            return (
                <t-space class="table-operations" space="small">
                {!editable && (
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={onEdit}>
                        编辑
                    </t-link>
                )}
                {editable && (
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={onSave}>
                        保存
                    </t-link>
                )}
                {editable && (
                    <t-link theme="danger" hover="color" data-id={row.index} onClick={onDelete}>
                        移除
                    </t-link>
                )}
                {editable && (
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={onCancel}>
                        取消
                    </t-link>
                )}
            </t-space>
            );
        }
    }
])
const billOfDocumentColumns = ref([
    { colKey: 'billOfDocumentId', title: '单据编号'},
    { colKey: 'status',title: '单据状态',
        cell: (h, { row }) => {
            // alert(JSON.stringify(row))
            return (
                <t-tag shape="round" theme={row.status==='待审批'?'warning':row.status==='已驳回'?'danger':'success'} variant="light-outline">
                    {row.status==='待审批'?<ErrorCircleFilledIcon />:row.status==='已驳回'?<CloseCircleFilledIcon />:<CheckCircleFilledIcon />}
                    {row.status}
                </t-tag>
            );
        },
    },
    { colKey: 'billOfDocumentCreateTime',title: '产生时间' },
    { colKey: 'billOfDocumentWarehouse', title: '所属仓库' },
    { colKey: 'billOfDocumentDepartment', title: '所属部门' },
    { colKey: 'billOfDocumentUnit', title: '供应商' },
    { colKey: 'billOfDocumentTransactor', title: '经办人' },
    { colKey: 'billOfDocumentAbstract', title: '摘要' },
    { colKey: 'billOfDocumentRemark', title: '附加说明' },
    { colKey: 'billOfDocumentAccrual', title: '发生额' },
    {
        title: '操作栏',
        colKey: 'operate',
        fixed: 'right',
        width: 250,
        cell: (h, { row }) => {
            return (
                <t-space class="table-operations" space="small">
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={showDetails}>
                        详情 
                    </t-link>
                    <t-link theme="success" hover="color" data-id={row.index} onClick={auding}>
                        通过
                    </t-link>
                    <t-link theme="danger" hover="color" data-id={row.index} onClick={reject}>
                        驳回 
                    </t-link>
                    <t-link theme="danger" hover="color" data-id={row.index} onClick={deleteBillOfDocument}>
                        删除
                    </t-link>
                    <t-link theme="primary" hover="color" data-id={row.index} onClick={print}>
                        打印 
                    </t-link>
                </t-space>
            );
        }
    }
])

const auding = (e)=>{
    const id = e.currentTarget.dataset.id
    request.AudingBillOfDocument(billOfDocumentList.value[id].billOfDocumentId,(res)=>{
        if(res.data && res.data.success){
            billOfDocumentList.value[id].status = '已审核'
            NotifyPlugin.success({
                    title: "成功",
                    content: '单据已审核。',
                    duration: 3000
            })
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '通过失败。',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
                title: "请求失败",
                content: '通过失败。' + err,
                duration: 3000
        })
    })
}
const reject = (e)=>{
    const id = e.currentTarget.dataset.id
    request.RejectBillOfDocument(billOfDocumentList.value[id].billOfDocumentId,(res)=>{
        if(res.data && res.data.success) {
            billOfDocumentList.value[id].status = '已驳回'
            NotifyPlugin.success({
                    title: "成功",
                    content: '单据已驳回。',
                    duration: 3000
            })
        }else {
            NotifyPlugin.error({
                title: "请求失败",
                content: '驳回失败。',
                duration: 3000
        })
        }
    },(err)=>{
        NotifyPlugin.error({
                title: "请求失败",
                content: '驳回失败。' + err,
                duration: 3000
        })
    })
}
const print = (e)=>{
    showPrintDialog.value = true
    const id = e.currentTarget.dataset.id
    billOfDocumentDetailsHead.value = billOfDocumentList.value[id]
    billOfDocumentDetailsGoodsList.value = billOfDocumentListGoodsList.value[id]
    printTime.value = billOfDocumentList.value[id].billOfDocumentCreateTime
    request.RequestPrintTemplateList((res)=>{
        if(res.data.success) {
            let data = res.data.data
            for(let i = 0; i < data.length; i++) {
                data[i].index = i
                templateOption.value[i] = []
                templateOption.value[i].label = data[i].printContent
                templateOption.value[i].value = data[i].printTemplate
            }

        }else{
            NotifyPlugin.error({
                title: "请求失败",
                content: '获取打印模板失败。',
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            title: "请求失败",
            content: '打印模板列表获取失败.' + err,
            duration: 3000
        })
    })
}
const confrimPrintTemplate = ()=>{
    let table_info = []
    let end_price = 0.00
    for(let i = 0;i < billOfDocumentDetailsGoodsList.value.length;i++){
        table_info[i] = {}
        table_info[i].index = i + 1
        table_info[i].name = billOfDocumentDetailsGoodsList.value[i].billOfDocumentGoodsName
        table_info[i].model = billOfDocumentDetailsGoodsList.value[i].billOfDocumentModel
        table_info[i].amount = billOfDocumentDetailsGoodsList.value[i].billOfDocumentGoodsAmount
        let price = parseFloat(billOfDocumentDetailsGoodsList.value[i].billOfDocumentGoodsPrice)
        table_info[i].price = isNaN(price) ? "" : "￥" + price
        let total_price = parseFloat(table_info[i].amount) * parseFloat(billOfDocumentDetailsGoodsList.value[i].billOfDocumentGoodsPrice)
        table_info[i].total_price = isNaN(total_price) ? "" : "￥" + total_price
        table_info[i].discost = billOfDocumentDetailsGoodsList.value[i].discount
        let discost_price = parseFloat(table_info[i].discost) / 100 * total_price
        table_info[i].discost_price = isNaN(discost_price) ? "" : "￥" + discost_price
        end_price += total_price
    }
    let printData = {
        transactor: billOfDocumentDetailsHead.value.billOfDocumentTransactor,
        data: printTime.value,
        bill_of_document_id: billOfDocumentDetailsHead.value.billOfDocumentId,
        table: table_info,
        end_price: isNaN(end_price)? "":"￥" + end_price
    }
    hiprintTemplate.value.print(printData)
}
const SelectPrintTemplateChange = (selectValue,context)=>{
    console.log(context)
    hiprintTemplate.value.update(JSON.parse(selectValue))
}
const SelectChange = (value,context)=>{
    console.log(value)
    if(context.option) {
        billOfDocumentCreateHead.warehouse = context.option.label
    } 
}
const showDetails = (e)=>{
    const id = e.currentTarget.dataset.id
    billOfDocumentDetailsHead.value = billOfDocumentList.value[id]
    billOfDocumentDetailsGoodsList.value = billOfDocumentListGoodsList.value[id]
    showBillOfDocumentDetailsDialog.value = true
    console.log(id) 
}
const deleteBillOfDocument = (e)=>{
    const id = e.currentTarget.dataset.id
    request.RequestDeletePurchaseBillOfDocument(billOfDocumentList.value[id].billOfDocumentId,"采购换货单",
    (res)=>{
        if(res.data.success) {
            billOfDocumentList.value.splice(id,1)
            billOfDocumentListGoodsList.value.splice(id,1)
            for(let i = 0 ;i < billOfDocumentList.value.length;i++) {
                billOfDocumentList.value[i].index = i
            }
            sessionStorage.setItem("采购换货单总数",parseInt(sessionStorage.getItem("采购换货单总数")) - 1)
            pageConfig.value.total--
            NotifyPlugin.success({
                placement: 'top-right',
                title: '删除成功',
                content: '采购换货单删除成功',
                duration: 3000,
            })
        }else {
            NotifyPlugin.error({
                placement: 'top-right',
                title: '删除失败',
                content: '采购换货单删除失败，请联系管理人员',
                duration: 3000,
            })
        }
    },(err)=>{
        NotifyPlugin.error({
            placement: 'top-right',
            title: '删除失败',
            content: '采购换货单删除失败，请联系管理人员' + err,
            duration: 3000,
        })
    })
}

const AddNewBillOfDocument = ()=>{
    let date = new Date()
    billOfDocumentCreateHead.id = 'HH' + date.getFullYear() + (date.getMonth() + 1) + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds()
    billOfDocumentCreateDataGoodsList.value = [] 
    currentSaveId.value = ''
    editableRowKeys.value = []
    bufferRowData.value = []
    showAddBillOfDocumentDialog.value = true
}
const AddCreateBillOfDocumentGoodsListItem = ()=>{
    billOfDocumentCreateDataGoodsList.value.push({index: '' + billOfDocumentCreateDataGoodsList.value.length})
}
const showColumnsConfig = ()=>{
    columnsConfigVisible.value = true
}

const SubmitAddBillOfDocument = (e)=>{
    //todo
    console.log(e)
    let goods_list = billOfDocumentCreateDataGoodsList.value.slice()
    goods_list.forEach((item)=>{
        delete item.index
    })
    request.RequestReplacementBillOfDocumentCreate(billOfDocumentCreateHead,goods_list,(res)=>{
        if(res.data.success) {
            if(billOfDocumentList.value.length < pageConfig.value.pageSize) {
                billOfDocumentList.value.push({
                    index: billOfDocumentList.value.length,
                    bindingUserId: parseInt(sessionStorage.getItem("user_id")),
                    billOfDocumentId: billOfDocumentCreateHead.id,
                    billOfDocumentTransactor: billOfDocumentCreateHead.transactor,
                    billOfDocumentWarehouse: billOfDocumentCreateHead.warehouse,
                    billOfDocumentUnit: billOfDocumentCreateHead.unit,
                    billOfDocumentDepartment: billOfDocumentCreateHead.department,
                    billOfDocumentAbstract: billOfDocumentCreateHead.abstract,
                    billOfDocumentRemark: billOfDocumentCreateHead.remark,
                })
                let list = []
                goods_list.forEach(item =>{
                    list.push({
                        batchNumber: item.batchNumber,
                        billOfDocumentBrand: item.billOfDocumentBrand,
                        billOfDocumentGoodsAmount: item.billOfDocumentGoodsAmount,
                        billOfDocumentGoodsHeight: item.billOfDocumentGoodsHeight,
                        billOfDocumentGoodsId: item.billOfDocumentGoodsId,
                        billOfDocumentGoodsLength: item.billOfDocumentGoodsLength,
                        billOfDocumentGoodsName: item.billOfDocumentGoodsName,
                        billOfDocumentGoodsPrice: item.billOfDocumentGoodsPrice,
                        billOfDocumentGoodsPriceIncludeTax: item.billOfDocumentGoodsPriceIncludeTax,
                        billOfDocumentGoodsWeight: item.billOfDocumentGoodsWeight,
                        billOfDocumentModel: item.billOfDocumentModel,
                        billOfDocumentPlaceOfProduction: item.billOfDocumentPlaceOfProduction,
                        discount: item.discount,
                        qualityGuaranteePeriod: item.qualityGuaranteePeriod,
                        bindingBillOfDocumentId: billOfDocumentCreateHead.id,
                        bindingUserId: parseInt(sessionStorage.getItem("user_id"))
                    })
                })
                billOfDocumentListGoodsList.value.push(list)
            }
            pageConfig.value.total++
            sessionStorage.setItem("采购换货单总数",parseInt(sessionStorage.getItem("采购换货单总数")) + 1)
            showAddBillOfDocumentDialog.value = false
            NotifyPlugin.success({
                    placement: 'top-right',
                    title: '创建成功',
                    content: '采购换货单创建成功',
                    duration: 3000
            })
        }else {
            showAddBillOfDocumentDialog.value = false
            NotifyPlugin.error({
                placement: 'top-right',
                title: '创建失败',
                content: '采购换货单创建失败，其联系管理人员',
                duration: 3000,
            })
        }
        
    },
    (err)=>{
        showAddBillOfDocumentDialog.value = false
        NotifyPlugin.error({
                placement: 'top-right',
                title: '创建失败',
                content: '采购换货单创建失败，其联系管理人员\n' + err,
                duration: 3000,
            })
    })
}
const ConfigRead = ()=>{
            if(!Config.value.idVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !== "billOfDocumentGoodsId"})
            else dispalyColumns.value.push("billOfDocumentGoodsId")
            if(!Config.value.nameVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsName"})
            else dispalyColumns.value.push("billOfDocumentGoodsName")

            if(!Config.value.weightVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsWeight"})
            else dispalyColumns.value.push("billOfDocumentGoodsWeight")
            if(!Config.value.heightVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsHeight"})
            else dispalyColumns.value.push("billOfDocumentGoodsHeight")
            if(!Config.value.lengthVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsLength"})
            else dispalyColumns.value.push("billOfDocumentGoodsLength") 
            if(!Config.value.brandVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentBrand"})
            else dispalyColumns.value.push("billOfDocumentBrand")
        
            if(!Config.value.amountVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsAmount"})
            else dispalyColumns.value.push("billOfDocumentGoodsAmount")
            if(!Config.value.modelVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentModel"})
            else dispalyColumns.value.push("billOfDocumentModel")
            if(!Config.value.placeOfProductionVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentPlaceOfProduction"})
            else dispalyColumns.value.push("billOfDocumentPlaceOfProduction")
            if(!Config.value.priceVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsPrice"})
            else dispalyColumns.value.push("billOfDocumentGoodsPrice")
            if(!Config.value.batchNumberVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="batchNumber"})
            else dispalyColumns.value.push("batchNumber")
            if(!Config.value.qualityGuaranteePeriodVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="qualityGuaranteePeriod"})
            else dispalyColumns.value.push("qualityGuaranteePeriod")
            if(!Config.value.discountVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="discount"})
            else dispalyColumns.value.push("discount")
            if(!Config.value.priceIncludeTaxVisible) dispalyColumns.value = dispalyColumns.value.filter( (item) => {return item !=="billOfDocumentGoodsPriceIncludeTax"})
            else dispalyColumns.value.push("billOfDocumentGoodsPriceIncludeTax")
}
const onDisplayColumnsChange = (params)=> {
    let value  = params
    if(value.currentColumn === undefined) {
        Config.value.idVisible = !Config.value.idVisible
        Config.value.nameVisible = !Config.value.nameVisible
        Config.value.weightVisible = !Config.value.weightVisible
        Config.value.heightVisible = !Config.value.heightVisible
        Config.value.lengthVisible = !Config.value.lengthVisible
        Config.value.brandVisible = !Config.value.brandVisible
        Config.value.amountVisible = !Config.value.amountVisible
        Config.value.modelVisible = !Config.value.modelVisible
        Config.value.placeOfProductionVisible = !Config.value.placeOfProductionVisible
        Config.value.priceVisible = !Config.value.priceVisible
        Config.value.batchNumberVisible = !Config.value.batchNumberVisible
        Config.value.qualityGuaranteePeriodVisible = !Config.value.qualityGuaranteePeriodVisible
        Config.value.discountVisible = !Config.value.discountVisible
        Config.value.priceIncludeTaxVisible = !Config.value.priceIncludeTaxVisible
    } else {
        if(value.currentColumn.colKey === 'billOfDocumentGoodsId') Config.value.idVisible = !Config.value.idVisible
        else if(value.currentColumn.colKey === 'billOfDocumentGoodsName') Config.value.nameVisible = !Config.value.nameVisible
        else if(value.currentColumn.colKey === 'billOfDocumentGoodsWeight') Config.value.weightVisible = !Config.value.weightVisible
        else if(value.currentColumn.colKey === 'billOfDocumentGoodsHeight') Config.value.heightVisible = !Config.value.heightVisible
        else if(value.currentColumn.colKey === 'billOfDocumentGoodsLength') Config.value.lengthVisible = !Config.value.lengthVisible
        else if(value.currentColumn.colKey === 'billOfDocumentBrand') Config.value.brandVisible = !Config.value.brandVisible
        else if(value.currentColumn.colKey === 'billOfDocumentGoodsAmount') Config.value.amountVisible = !Config.value.amountVisible
        else if(value.currentColumn.colKey === 'billOfDocumentModel') Config.value.modelVisible = !Config.value.modelVisible
        else if(value.currentColumn.colKey === 'billOfDocumentPlaceOfProduction') Config.value.placeOfProductionVisible = !Config.value.placeOfProductionVisible
        else if(value.currentColumn.colKey === 'billOfDocumentGoodsPrice') Config.value.priceVisible = !Config.value.priceVisible
        else if(value.currentColumn.colKey === 'batchNumber') Config.value.batchNumberVisible = !Config.value.batchNumberVisible
        else if(value.currentColumn.colKey === 'qualityGuaranteePeriod') Config.value.qualityGuaranteePeriodVisible = !Config.value.qualityGuaranteePeriodVisible
        else if(value.currentColumn.colKey === 'discount') Config.value.discountVisible = !Config.value.discountVisible
        else if(value.currentColumn.colKey === 'billOfDocumentGoodsPriceIncludeTax') Config.value.priceIncludeTaxVisible = !Config.value.priceIncludeTaxVisible
    }
    ConfigRead()
    request.RequestConfigModify("采购换货单",Config,(res)=>{
        if(res.data.success) {
            let config = JSON.parse(sessionStorage.getItem("config"))
            for(let i = 0; i< config.length;i++) {
                if(config[i].type === "采购换货单") {
                    config[i] = Config.value
                    sessionStorage.setItem("config",JSON.stringify(config))
                    break;
                }
            }
            NotifyPlugin.success({
                title: "配置修改成功",
                message: "采购换货单配置修改成功",
                duration: 3000
            })
        }else {
            NotifyPlugin.error({
                title: "配置修改失败",
                message: "采购换货单配置修改失败",
                duration: 3000
            })
        }
    },(err)=>{
        NotifyPlugin.error({
                title: "配置修改失败",
                message: "采购换货单配置修改失败" + err,
                duration: 3000
            })
    })
}
const onEdit = (e)=>{
    const { id } = e.currentTarget.dataset
    if (!editableRowKeys.value.includes(id)) {
        editableRowKeys.value.push(id);
        Object.assign(bufferRowData.value, billOfDocumentCreateDataGoodsList.value[id])
    }
}

const onSave = (e)=>{
    const {id} = e.currentTarget.dataset
    currentSaveId.value = id
    updateEditState(id)
    if(!Object.hasOwn(bufferRowData.value, 'index')) {
        Object.defineProperty(bufferRowData.value, 'index', {
            value: currentSaveId.value,
            enumerable: true,
            writable: true
        })
    }
    bufferRowData.value.index = id
    let newOne = {}
    Object.assign(newOne, bufferRowData.value)
    billOfDocumentCreateDataGoodsList.value[id] = newOne
    tableRef.value.clearValidateData();
    bufferRowData.value = {}
}
const onDelete = (e)=>{
    const {id} = e.currentTarget.dataset;
    updateEditState(id)
    tableRef.value.clearValidateData();
    if(billOfDocumentCreateDataGoodsList.value.length === 1) {
        billOfDocumentCreateDataGoodsList.value = []
    }else {
        billOfDocumentCreateDataGoodsList.value.splice(id,1)
    }
}
const onCancel = (e)=>{
    const { id } = e.currentTarget.dataset;
    updateEditState(id)
    tableRef.value.clearValidateData();
    bufferRowData.value = {};
}
const onRowEdit = (e)=>{
    if(!Object.hasOwn(bufferRowData.value, e.col.colKey)) {
        Object.defineProperty(bufferRowData.value, e.col.colKey, {
            value: e.value,
            enumerable: true,
            writable: true
        })
    }else {
        bufferRowData.value[e.col.colKey] = e.value
    }
}
const updateEditState = (id) => {
    const index = editableRowKeys.value.findIndex((t) => t === id);
    editableRowKeys.value.splice(index, 1);
};

const staffList = ref([])
const fetchStaffList = ()=>{
    request.RequestStaffInfo(1,65535,null,
    (res)=>{
        if(res.data.success) {
            res.data.data.forEach(element => {
                staffList.value.push(element)
            });
        }
    },
    (err)=>{
        NotifyPlugin.error({
                title: "请求失败",
                content: '员工信息请求失败.' + err,
            })
    })
}
const transactorSelectChange = (value,context)=>{
    console.log(value)
    if(context.option) {
        billOfDocumentCreateHead.transactor = context.option.label
    }
}
</script>

<style scoped>
</style>